export const DOT_ICON = `<?xml version="1.0" encoding="UTF-8"?>
<svg fill="none" viewBox="0 0 6 6" xmlns="http://www.w3.org/2000/svg">
<circle cx="3" cy="3" r="3" fill="#106B8E"/>
</svg>`;

export const DOT_ICON_O = `<?xml version="1.0" encoding="UTF-8"?>
<svg fill="none" viewBox="0 0 6 6" xmlns="http://www.w3.org/2000/svg">
<circle cx="3" cy="3" r="3" fill="#E3E3E3"/>
</svg>
`;
